import React, {FC, ReactElement} from 'react';

//MUI
import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';

import IsoLogo from '@/components/logos/IsoLogo';

const styles = {
  container: {
    height: '100vh'
  },
  logoContainer: {
    bgcolor: 'primary.main',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    mb: 12,
    position: 'relative'
  },
};
const HasfScreenWrapper: FC<{children: Array<ReactElement>}> = ({children}) => {

  return <Grid container component="main" sx={styles.container}>
    <Grid size={{xs: 0, sm: 4, md: 5}} component={Paper} elevation={6} square sx={styles.logoContainer}>
      <IsoLogo height="40%"/>
    </Grid>
    <Grid size={{xs: 12, sm: 8, md: 7}} sx={styles.formContainer}>
      {children}
    </Grid>
  </Grid>;
};

export default HasfScreenWrapper;